import gql from "graphql-tag";
import Fragments from "features/quote/fragments";

export const UPDATE_QUOTE = gql`
  mutation updateQuote($input: UpdateQuoteInput!) {
    updateQuote(input: $input) {
      quoteId
      transactionId
      estimationName
      isEstimation
      quoteStatusId
      quoteStatusCode
      quoteStatusName
      partnerId
      partnerTypeId
      quoteHeaderPartnerName
      currencyId
      currencyCode
    }
  }
`;

export const SAVE_PARTNER = gql`
  mutation savePartner($input: NewClientInput!) {
    savePartner(input: $input)
  }
`;

export const SAVE_QUOTE_PARTNERS = gql`
  mutation saveQuotePartners($input: NewQuotePartnerInput!) {
    saveQuotePartners(input: $input)
  }
`;

export const REMOVE_QUOTE_PARTNERS = gql`
  mutation removeQuotePartners($quoteId: Int!) {
    removeQuotePartners(quoteId: $quoteId)
  }
`;

export const ACTIVATE_QUOTE_FROM_ESTIMATION = gql`
  mutation activateQuoteFromEstimation($quoteId: Int!) {
    activateQuoteFromEstimation(quoteId: $quoteId) {
      ...quote
    }
  }
  ${Fragments.quote}
`;

export const ADD_CONTACT_CONSENT = gql`
  mutation addContactConsent($input: ContactConsentInput!) {
    addContactConsent(input: $input)
  }
`;

export const SEND_REQUEST_GDPR_CONSENT_EMAIL_LINK = gql`
  mutation sendRequestGdprConsentEmailLink($input: ContactConsentInput!) {
    sendRequestGdprConsentEmailLink(input: $input)
  }
`;

export const SAVE_PARTNER_FOR_SOLE_TRADER_FEATURE = gql`
  mutation savePartnerForSoleTraderFeature($input: NewPartnerForSoleTraderFeatureInput!) {
    savePartnerForSoleTraderFeature(input: $input)
  }
`;
